import {
  CsegmentedpanelVariant,
  type CsegmentedpanelPresentation,
} from "./csegmentedpanel.types";

export const CSEGMENTED_PANEL_PRESENTATION: Record<
  CsegmentedpanelVariant,
  CsegmentedpanelPresentation
> = {
  [CsegmentedpanelVariant.Seamed]: {
    container: {
      gap: 1,
      overflow: "hidden",
      borderRadius: 10,
      backgroundColor: "rgba(255,255,255,0.045)",
      boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.05)",
    },
    cell: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      minWidth: 0,
      padding: "9px 11px",
      backgroundColor: "rgba(6,10,9,0.92)",
    },
    label: { color: "rgba(255,255,255,0.36)" },
    value: {},
    hasToneRail: false,
  },
  [CsegmentedpanelVariant.InsetCells]: {
    container: {
      gap: 6,
      padding: 6,
      overflow: "hidden",
      borderRadius: 13,
      backgroundColor: "rgba(0,0,0,0.24)",
      backgroundImage:
        "radial-gradient(circle at 10% 0%, rgba(102,254,193,0.045), transparent 36%)",
      boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.055)",
    },
    cell: {
      display: "flex",
      flexDirection: "column",
      gap: 5,
      minWidth: 0,
      padding: "10px 11px",
      borderRadius: 9,
      backgroundImage:
        "linear-gradient(145deg, rgba(255,255,255,0.055), rgba(255,255,255,0.015))",
      boxShadow:
        "inset 0 0 0 1px rgba(255,255,255,0.065), 0 8px 18px -16px rgba(0,0,0,0.9)",
    },
    label: { color: "rgba(255,255,255,0.42)" },
    value: { fontSize: 13 },
    hasToneRail: false,
  },
  [CsegmentedpanelVariant.SignalRails]: {
    container: {
      gap: 1,
      overflow: "hidden",
      borderRadius: 10,
      backgroundColor: "rgba(255,255,255,0.05)",
      boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.055)",
    },
    cell: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: 6,
      minWidth: 0,
      padding: "12px 11px 10px",
      backgroundImage:
        "linear-gradient(180deg, rgba(255,255,255,0.035), rgba(2,7,6,0.9) 48%)",
    },
    label: {
      fontSize: 8,
      color: "rgba(255,255,255,0.44)",
    },
    value: {
      fontSize: 13.5,
      fontWeight: 700,
    },
    hasToneRail: true,
  },
  [CsegmentedpanelVariant.LabelBands]: {
    container: {
      gap: 1,
      overflow: "hidden",
      borderRadius: 10,
      backgroundColor: "rgba(255,255,255,0.05)",
      boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.055)",
    },
    cell: {
      display: "flex",
      flexDirection: "column",
      gap: 0,
      minWidth: 0,
      padding: 0,
      backgroundColor: "rgba(5,10,9,0.9)",
    },
    label: {
      display: "block",
      padding: "7px 10px 5px",
      color: "rgba(255,255,255,0.42)",
      backgroundColor: "rgba(255,255,255,0.035)",
      borderBottom: "1px solid rgba(255,255,255,0.045)",
    },
    value: {
      display: "block",
      padding: "7px 10px 9px",
      fontSize: 13,
    },
    hasToneRail: false,
  },
};
